import brandDefinitions from "./brands.json";

const BRANDS = brandDefinitions;

/**
 * Resolve brand from build-time configuration and protect deployments against
 * a bundle served from the wrong white-label hostname.
 */
function resolveBrand() {
  const buildBrand = process.env.REACT_APP_BRAND || "";

  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    const hostnameBrand =
      host.includes("foerster") || host.includes("förster") || host.includes("smart-tag") || host.includes("smarttag")
        ? "foerstertag"
        : host.includes("biotagplus") || host.includes("bigdutchman")
          ? "biotagplus"
          : host.includes("calfhealth") || host.includes("lisa-cattle")
            ? "calfhealth"
            : null;

    if (hostnameBrand && hostnameBrand !== buildBrand) {
      console.warn(
        `[brandConfig] Brand mismatch! Build="${buildBrand}" but hostname="${host}". ` +
        `Forcing ${hostnameBrand} brand. Fix the deploy pipeline!`
      );
      return hostnameBrand;
    }
  }

  // This repository is the cattle product. Missing/invalid configuration must
  // never silently activate pig or generic livestock workflows.
  return BRANDS[buildBrand] ? buildBrand : "calfhealth";
}

const BRAND = resolveBrand();
const brandConfig = BRANDS[BRAND] || BRANDS.calfhealth;
const isBioTagPlus = BRAND === "biotagplus";
const isBioCV = BRAND === "biocv";
const isCalfHealth = BRAND === "calfhealth";
const isFoersterTag = BRAND === "foerstertag";
const isCattleApp = brandConfig.productProfile === "cattle";
const hasCapability = (capability) => brandConfig.capabilities.includes(capability);

export {
  BRANDS,
  BRAND,
  hasCapability,
  isBioTagPlus,
  isBioCV,
  isCalfHealth,
  isFoersterTag,
  isCattleApp,
};
export default brandConfig;
